export default "__VITE_ASSET__BWRMIfee__";